import type { Definition } from '~/types'

export const PageOffices: Definition = {
  contentType: 'PageOffices',
  fields: [
    {
      id: 'pointsOfContact',
      name: 'Points of contact',
      type: 'Array',
      subType: 'ModuleMediaCard'
    },
    {
      id: 'description',
      name: 'Description',
      type: 'Symbol'
    },
    {
      id: 'image',
      name: 'Image',
      type: 'ModuleMedia',
      imageOptions: { resize: true }
    }
  ]
}

export default {
  PageOffices
}
